import { Injectable } from '@angular/core'

import { BookingItem } from './booking-item'

@Injectable()
export class BookingItemSerializer {
  fromJson(json: any): BookingItem {
    const bookingItem = json

    return bookingItem
  }

  toJson(bookingitem: BookingItem): any {
    return {
      ...bookingitem
    }
  }
}
